import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import typography from "assets/theme/base/typography";

function Footer() {
  const { size } = typography;

  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" flexWrap="wrap" color="text" fontSize={size.sm} px={1.5}>
      &copy; {new Date().getFullYear()} v1.0.4, made with
      <MDBox fontSize={size.md} color="text" mb={-0.5} mx={0.25}>
        <Icon color="inherit" fontSize="inherit">
          favorite
        </Icon>
      </MDBox>
      by
        <MDTypography variant="button" fontWeight="medium">
          &nbsp;GreenMango&nbsp;
        </MDTypography>
      for a better web.
    </MDBox>
  );
}

export default Footer;
